/**
 * Purpose: load global data
 */

import axios from 'axios'

// state
const state = {
	billingStatus: [],
	cancelTypes: [],
	certifications: [],
	clients: [],
	confirmTypes: [],
	confirmWithClient: [],
	emailTypes: [],
	homeCities: [],
	homeRegions: [],
	jobTypes: [],
	languages: [],
	locations: [],
	messageTemplates: [],
	methods: [],
	rateTypes: [],
	ratings: [],
	regions: [],
	remarkTypes: [],
	requestStatus: [],
	requestTypes: [],
	serviceTypes: [],
	staff: [],
	states: [],
	status: [],
	vendorStatus: [],
	vendorView: [],

	//Misc
	timestamp: '',
	datetime: '',
	baseURL: '',

}

const getters = {
}


// mutations
const mutations = {
	SET_BILLING_STATUS (state, billingStatus){
		state.billingStatus = billingStatus
	},

	SET_CANCEL_TYPES (state, cancelTypes){
		state.cancelTypes = cancelTypes
	},

	SET_CERTIFICATIONS (state, certifications){
		state.certifications = certifications
	},

	SET_CLIENTS (state, clients){
		state.clients = clients
	},

	SET_CONFIRM_TYPES (state, confirmTypes){
		state.confirmTypes = confirmTypes
	},

	SET_CONFIRM_WITH_CLIENT (state, confirmWithClient){
		state.confirmWithClient = confirmWithClient
	},

	SET_EMAIL_TYPES (state, emailTypes){
		state.emailTypes = emailTypes
	},

	SET_HOME_CITIES (state, cities){
		state.homeCities = cities
	},

	SET_HOME_REGIONS (state, regions){
		state.homeRegions = regions
	},

	SET_JOB_TYPES(state, jobTypes){
		state.jobTypes = jobTypes
	},

	SET_LANGUAGES (state, languages){
		state.languages = languages
	},

	SET_LOCATIONS (state, locations){
		state.locations = locations
	},

	SET_MESSAGE_TEMPLATES (state, messageTemplates){
		state.messageTemplates = messageTemplates
	},

	SET_METHODS (state, methods){
		state.methods = methods
	},

	SET_RATE_TYPES (state, rateTypes){
		state.rateTypes = rateTypes
	},


	SET_REGIONS (state, regions){
		state.regions = regions
	},

	SET_RATINGS (state, ratings){
		state.ratings = ratings
	},

	SET_REMARK_TYPES (state, remarkTypes){
		state.remarkTypes = remarkTypes
	},

	SET_REQUEST_STATUS (state, requestStatus){
		state.requestStatus = requestStatus
	},

	SET_REQUEST_TYPES (state, requestTypes){
		state.requestTypes = requestTypes
	},

	SET_SERVICE_TYPES (state, serviceTypes){
		state.serviceTypes = serviceTypes
	},

	SET_STAFF (state, staff){
		state.staff = staff
	},

	SET_STATES (state, states){
		state.states = states
	},

	SET_STATUS (state, status){
		state.status = status
	},

	SET_VENDOR_STATUS (state, vendorStatus){
		state.vendorStatus = vendorStatus
	},

	SET_VENDOR_VIEW (state, vendorView){
		state.vendorView = vendorView
	},

	SET_TIMESTAMP (state, timestamp){
		state.timestamp = timestamp
	},

	SET_DATETIME (state, datetime){
		state.datetime = datetime
	},

	SET_BASE_URL (state, baseURL){
		state.baseURL = baseURL
	}
}

// actions
const actions = {
	getBillingStatus ({commit, getters, rootState, dispatch, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/billing-status?paginate=false';

		var billingStatusData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

            $.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	billing_status: arr['billing_status']
                };

                billingStatusData.push(obj);
            });
			//console.log(billingStatusData);
			commit('SET_BILLING_STATUS', billingStatusData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getCancelTypes ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/cancel-types?paginate=false';

		var cancelTypesData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

            $.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	cancel_type: arr['cancel_type']
                };

                cancelTypesData.push(obj);
            });
			//console.log(cancelTypesData);
			commit('SET_CANCEL_TYPES', cancelTypesData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getCertifications ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/certifications?paginate=false';

		var certificationsData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

            $.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	certification: arr['certification']
                };

                certificationsData.push(obj);
            });
			//console.log(certificationsData);
			commit('SET_CERTIFICATIONS', certificationsData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getHomeCities ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/view-cities?paginate=false';

		var cityData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

			$.each(result, function(idx, arr){
                obj = {
                	id: arr['home_city'],
                	home_city: arr['home_city']
                };

                cityData.push(obj);
            });
			commit('SET_HOME_CITIES', cityData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getHomeRegions ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/view-regions?paginate=false';

		var regionData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

			$.each(result, function(idx, arr){
                obj = {
                	id: arr['home_region'],
                	home_region: arr['home_region']
                };

                regionData.push(obj);
            });
			commit('SET_HOME_REGIONS', regionData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getClients ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/clients?paginate=false';

		var clientData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

			$.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	client_name: arr['client_name']
                };

                clientData.push(obj);
            });
			//console.log(clientData);
			commit('SET_CLIENTS', clientData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getConfirmTypes ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/confirm-types?paginate=false';

		var confirmTypesData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

            $.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	confirm_type: arr['confirm_type']
                };

                confirmTypesData.push(obj);
            });
			//console.log(confirmTypesData);
			commit('SET_CONFIRM_TYPES', confirmTypesData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getEmailTypes ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/email-types?paginate=false';

		var emailTypesData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

            $.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	email_type: arr['email_type']
                };

                emailTypesData.push(obj);
            });
			//console.log(emailTypesData);
			commit('SET_EMAIL_TYPES', emailTypesData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getJobTypes ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/job-types?sort=job_type:asc&paginate=false';

		var jobTypesData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

            $.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	job_type: arr['job_type']
                };

                jobTypesData.push(obj);
            });
			//console.log(jobTypesData);
			commit('SET_JOB_TYPES', jobTypesData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getLanguages ({commit, getters, rootState, dispatch, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/languages?sort=language:asc&paginate=false';

		var langData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

			//Insert a blank option
			obj = {
            	id: '',
            	language: '\u00A0'
            };
            langData.push(obj);

			$.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	language: arr['language']
                };

                langData.push(obj);
            });
			//console.log(langData);
			commit('SET_LANGUAGES', langData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getLocations ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var client_id = rootState.auth.user.client_id;
		var url = rootState.auth.l+'v1/locations?sort=location_name:asc&paginate=false';

		var locData = [];

		var getData = {
			client_id: client_id
		}

        $.ajax({
        	url: url,
			data: getData,
			type: 'GET',
			beforeSend: function(xhr){xhr.setRequestHeader('Authorization', 'Bearer ' + rootState.auth.a);},
         	success: function(response) {
				var result = response.data;

				var obj = {};

				//Insert a blank option
				obj = {
            		id: '',
            		location_name: '\u00A0'
	            };
	            locData.push(obj);

	            obj = {
            		id: '0',
            		location_name: '+ Add a new location'
	            };

	            locData.push(obj);

				$.each(result, function(idx, arr){
	                obj = {
	                	id: arr['id'],
	                	location_name: arr['location_name']
	                };

	                locData.push(obj);
	            });

	            //console.log(locData);
				commit('SET_LOCATIONS', locData);
         	},
			error: function (xhr, ajaxOptions, error) {
				dispatch('auth/checkErrorAjax', xhr, {root: true})
			}
        });

		/*axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

			$.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	location_name: arr['location_name']
                };

                locData.push(obj);
            });
			commit('SET_LOCATIONS', locData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		}); */
	},

	getMessageTemplates ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/email-templates?email_type_id=2&paginate=false';

		var messageTemplatesData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

            $.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	name: arr['name'],
                	//email_type_id: arr['email_type_id'], //There's really no need to get this
                	from: arr['from'],
                	cc: arr['bcc'],
                	subject: arr['subject'],
                	body: arr['body']

                };

                messageTemplatesData.push(obj);
            });
			//console.log(methodsData);
			commit('SET_MESSAGE_TEMPLATES', messageTemplatesData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});

	},

	getMethods ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/methods?paginate=false';

		var methodsData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

            $.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	method: arr['method']
                };

                methodsData.push(obj);
            });
			//console.log(methodsData);
			commit('SET_METHODS', methodsData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getConfirmWithClient ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/confirm-with-client';

		var confirmWithClientData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

            $.each(result, function(idx, arr){
            	obj = {
                	id: arr['id'],
                	name: arr['name']
                };

                confirmWithClientData.push(obj);
            });
			commit('SET_CONFIRM_WITH_CLIENT', confirmWithClientData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getRateTypes ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/rate-types?paginate=false';

		var rateTypesData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

            $.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	rate_type: arr['rate_type']
                };

                rateTypesData.push(obj);
            });
			//console.log(rateTypesData);
			commit('SET_RATE_TYPES', rateTypesData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getRatings ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/ratings?paginate=false';

		var ratingsData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

			obj = {
            	id: '',
            	rating: ' - SELECT - '
            };

            ratingsData.push(obj);

            $.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	rating: arr['rating']
                };

                ratingsData.push(obj);
            });
			//console.log(rateTypesData);
			commit('SET_RATINGS', ratingsData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getRegions ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/regions?paginate=false';

		var regionsData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

            $.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	region: arr['region']
                };

                regionsData.push(obj);
            });
			//console.log(regionsData);
			commit('SET_REGIONS', regionsData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getRemarkTypes ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/remark-types?paginate=false';

		var remarkTypesData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

            $.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	remark_type: arr['remark_type']
                };

                remarkTypesData.push(obj);
            });
			//console.log(remarkTypesData);
			commit('SET_REMARK_TYPES', remarkTypesData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getRequestStatus ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/request-status?paginate=false';

		var requestStatusData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

            $.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	request_status: arr['request_status']
                };

                requestStatusData.push(obj);
            });
			//console.log(requestStatusData);
			commit('SET_REQUEST_STATUS', requestStatusData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getRequestTypes ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/request-types?paginate=false';

		var requestTypesData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

            $.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	request_type: arr['request_type']
                };

                requestTypesData.push(obj);
            });
			//console.log(requestTypesData);
			commit('SET_REQUEST_TYPES', requestTypesData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getServiceTypes ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/service-types?sort=id:asc&paginate=false';

		var serviceTypesData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

            $.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	service_type: arr['service_type']
                };

                serviceTypesData.push(obj);
            });
			//console.log(serviceTypesData);
			commit('SET_SERVICE_TYPES', serviceTypesData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getStaff ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/staff?paginate=false';

		var staffData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

            $.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	abbr: arr['abbr']
                };

                staffData.push(obj);
            });
			//console.log(staffData);
			commit('SET_STAFF', staffData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getStates ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/states?paginate=false';

		var statesData = [];

		axios.get(url,header).then(response => {
			var result = response.data.data;
			var obj = {};

            $.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	abbr: arr['abbr'],
                	name: arr['name']
                };

                statesData.push(obj);
            });
			//console.log(statesData);
			commit('SET_STATES', statesData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getStatus ({commit, getters, rootState, rootGetters}){

		var statusData = [
			{
				id: 0,
				status: 'Inactive'
			},
			{
				id: 1,
				status: 'Active'
			}
		];

		//console.log(statusData);
		commit('SET_STATUS', statusData);

	},

	getVendorStatus ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/vendor-status?paginate=false';

		var vendorStatusData = [];
		var obj = {};

		obj = {
        	id: '',
        	vendor_status: ' - SELECT - '
        };

        vendorStatusData.push(obj);

		axios.get(url,header).then(response => {
			var result = response.data.data;


            $.each(result, function(idx, arr){
                obj = {
                	id: arr['id'],
                	vendor_status: arr['vendor_status']
                };

                vendorStatusData.push(obj);
            });
			//console.log(vendorStatusData);
			commit('SET_VENDOR_STATUS', vendorStatusData);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getVendorView ({commit, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var url = rootState.auth.l+'v1/view-vendors';

		axios.get(url,header).then(response => {
			var result = response.data;
			//console.log(result);
			//console.log(vendorStatusData);
			commit('SET_VENDOR_VIEW', result);
		}).catch((error) => {
			dispatch('auth/checkError', error, {root: true});
		});
	},

	getTimestamp({commit}){

		var today = new Date();
		var dd = today.getDate();
		var mm = today.getMonth()+1; //January is 0!
		var yyyy = String(today.getFullYear());
		var curHour = today.getHours() > 12 ? today.getHours() - 12 : (today.getHours() < 10 ? "0" + today.getHours() : today.getHours());
		var curMinute = today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes();
		var curSeconds = today.getSeconds() < 10 ? "0" + today.getSeconds() : today.getSeconds();


		if(dd<10) {
		    dd = '0'+dd
		}

		if(mm<10) {
		    mm = '0'+mm
		}

		var timestamp = yyyy + mm + dd + '_' + curHour + curMinute + curSeconds;
		var datetime = mm + '/' + dd + '/' + yyyy.substring(2, 4) + ' ' + curHour + ':' + curMinute;

		commit('SET_TIMESTAMP', timestamp);
		commit('SET_DATETIME', datetime);
	},

	// this is being used in password reset so we can send client's url to api and use in email send.
	getBaseURL({commit}){
	    var url = location.href;  // entire url including querystring - also: window.location.href;
	    var baseURL = url.substring(0, url.indexOf('/', 14));

	    commit('SET_BASE_URL', baseURL);
	},
}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
	actions
}
